import { Button, Card, TextArea, BodyText } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import React, { useState } from 'react'
import classNames from 'classnames'
import { useMessage } from '../../hooks/useMessage'
import { ARTICLE_FEEDBACK_REASON_DATA } from '../../utils/prop-type-shape'

import './article-feedback-reason.less'

const formMetaData = {
  reasons: [
    'toomuchinfo',
    'notenoughinfo',
    'lookingfor',
    'incorrect',
    'dontlike',
    'other',
  ],
  rows: 3,
  maxLength: 100,
}
const ArticleFeedbackReason = ({ onSubmit }) => {
  const [selectedReason, setSelectedReason] = useState('')
  const [reasonDesc, setReasonDesc] = useState('')
  const { getMessage } = useMessage()

  const reasonClickHandler = (reason) => {
    setSelectedReason(reason)
  }

  const reasonSubmitHandler = () => {
    onSubmit(selectedReason, reasonDesc)
  }

  const renderReasonDescriptionForm = (reason) => {
    if (reason !== selectedReason) {
      return null
    }
    return (
      <>
        <TextArea
          className="hc_fb_reason_option__desc"
          inputClassName="hc_fb_reason_option__desc--input"
          onChange={(e) => setReasonDesc(e.target.value)}
          maxCharacters={formMetaData.maxLength}
          rows={formMetaData.rows}
          showCharacterCounter={true}
          maxLength={formMetaData.maxLength}
          placeholder={getMessage(
            'app.article.feedback.reason.form.placeholder',
          )}
          data-testid="hc-fb-reason-option-desc"
        />
        <Button
          className="hc_fb_reason_option__btn_submit"
          fullWidthOnMobile={false}
          onClick={reasonSubmitHandler}
          size="sm"
          data-testid="hc-fb-reason-option-btn-submit"
        >
          <Message id="app.article.feedback.reason.form.submit" />
        </Button>
      </>
    )
  }

  const renderReasons = () => {
    const { reasons } = formMetaData
    return (
      <ul
        data-testid="hc-fb-reason-options-section"
        className="hc_fb_reason_options__section"
      >
        {reasons.map((reason) => {
          return (
            <li key={`hc_fb_reason_option_heading_${reason}`}>
              <BodyText
                className={classNames('hc_fb_reason_option__title', {
                  'hc_fb_reason_option__title--selected':
                    reason === selectedReason,
                })}
                onClick={() => reasonClickHandler(reason)}
                data-testid="hc-fb-reason-option-title"
                role="button"
              >
                <Message id={`app.article.feedback.reason.${reason}`} />
              </BodyText>
              {renderReasonDescriptionForm(reason)}
            </li>
          )
        })}
      </ul>
    )
  }

  return (
    <Card className="hc_fb_reason">
      <BodyText
        data-testid="hc-fb-reason-title"
        className="hc_fb_reason__title"
        strong
      >
        <Message id="app.article.feedback.reason.form.header" />
      </BodyText>
      {renderReasons()}
    </Card>
  )
}

ArticleFeedbackReason.propTypes = ARTICLE_FEEDBACK_REASON_DATA

export default ArticleFeedbackReason
